import * as api from "../../../api";
import { buildAlertWithLocalizedMessages } from "../..";
import { jsError } from "../../../common/utils";
/* export * from "./authentication"; */

export const getAllSkillsForPersons = (detailed) => dispatch => {
  dispatch({ type: "GET_ALL_SKILLS_LOADING" });
  api
    .skillsGetAllForPersons(detailed)
    .then(resp => {
      dispatch(operationSucceeded(resp.data));
      dispatch({ type: "GET_ALL_SKILLS_LOADING_DONE" });
    })
    .catch(e => {
      jsError(e);
      dispatch({ type: "GET_ALL_SKILLS_LOADING_DONE" });
      dispatch(operationFail());
      dispatch(buildAlertWithLocalizedMessages(
        "ERROR",
        "GetAllSkillsErrorAlertTitle",
        "Virhe taitojen haussa",
        e.response && e.response.data && e.response.data.localizedMessages ? e.response.data.localizedMessages : null));
    });
};

const operationSucceeded = data => ({
  type: "GET_ALL_SKILLS_SUCCEEDED",
  payload: { skills: data },
});

const operationFail = () => ({
  type: "GET_ALL_SKILLS_FAIL",
});
